import { Types } from "../actions/accountingActions";
import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';

const accountingReducers = (state, action) => {
	switch (action.type) {
		case Types.ACCOUNTING_GET_DATA: {
			let newState = _.cloneDeep(state);

			newState.accounting.ledgers.data = action.data?.ledgers?.data ?? [];
			newState.accounting.costCenters.data = action.data?.costCenters?.data ?? [];
			newState.accounting.journals.selectedLevels = action.data?.journals?.data ?? [];
			newState.accounting.journals.conditions = action.data?.conditions ?? [];

			return newState;
		}
		case Types.ACCOUNTING_IMPORT_FILE: {
			let newState = _.cloneDeep(state);

			newState.accounting.fileImport.fileName = action.fileName;
			newState.accounting.fileImport.processingFile = true;

			return newState;
		}
		case Types.ACCOUNTING_FILE_DATA_LOADED: {
			let newState = _.cloneDeep(state);

			newState.accounting.fileImport.processingFile = false;
			newState.accounting.fileImport.fields = action.fields;
			newState.accounting.fileImport.data = action.data;
			newState.accounting.fileImport.dataToSend = false;

			return newState;
		}
		case Types.ACCOUNTING_CLEAR_FILE: {
			let newState = _.cloneDeep(state);

			newState.accounting.fileImport.fileName = null;
			newState.accounting.fileImport.fields = null;
			newState.accounting.fileImport.data = null;
			newState.accounting.fileImport.dataToSend = null;

			return newState;
		}
		case Types.ACCOUNTING_SAVE_LEDGERS: {
			let newState = _.cloneDeep(state);

			newState.accounting.ledgers.data = action.data;
			newState.accounting.ledgers.dirty = false;

			return newState;
		}
		case Types.ACCOUNTING_UPDATE_LEDGERS: {
			let newState = _.cloneDeep(state);

			newState.accounting.ledgers.data = action.data;

			// dirty state is to show that the data has been changed and needs to be saved
			newState.accounting.ledgers.dirty = true;

			return newState;
		}
		case Types.ACCOUNTING_SAVE_COST_CENTERS: {
			let newState = _.cloneDeep(state);

			newState.accounting.costCenters.data = action.data;
			newState.accounting.costCenters.dirty = false;

			return newState;
		}
		case Types.ACCOUNTING_UPDATE_COST_CENTERS: {
			let newState = _.cloneDeep(state);

			newState.accounting.costCenters.data = action.data;

			// dirty state is to show that the data has been changed and needs to be saved
			newState.accounting.costCenters.dirty = true;

			return newState;
		}
		case Types.ACCOUNTING_UPDATE_JOURNALS: {
			let newState = _.cloneDeep(state);

			newState.accounting.journals.selectedLevels = action.selectedLevels;
			newState.accounting.journals.dirty = true;

			return newState;
		}
		case Types.ACCOUNTING_SAVE_JOURNALS: {
			let newState = _.cloneDeep(state);

			newState.accounting.journals.selectedLevels = action.selectedLevels;
			newState.accounting.journals.dirty = false;

			return newState;
		}
		case Types.ACCOUNTING_SAVE_CONDITIONS: {
			let newState = _.cloneDeep(state);

			newState.accounting.journals.conditions = action.data;

			return newState;
		}
		case Types.ACCOUNTING_UPDATE_JOURNAL_CONDITION: {
			let newState = _.cloneDeep(state);

			console.log('ACCOUNTING_UPDATE_JOURNAL_CONDITION', action.data)

			const {
				field,
				value,
				row,
				part,
				type, // when or set
				action: actionType,
			} = action.data;

			if (!newState.accounting.journals.conditions[row]) {
				newState.accounting.journals.conditions[row] = {
					id: uuidv4(),
				};
			}
			newState.accounting.journals.conditions[row].dirty = true;

			if(!newState.accounting.journals.conditions[row][type]) {
				newState.accounting.journals.conditions[row][type] = [];
			}

			if (!newState.accounting.journals.conditions[row][type][part]) {
				newState.accounting.journals.conditions[row][type][part] = {};
			}

			if (actionType === "remove") {

				// if part has a percentage, add it to the first part
				if (newState.accounting.journals.conditions[row][type][part].percentage) {
					newState.accounting.journals.conditions[row][type][0].percentage = parseFloat(newState.accounting.journals.conditions[row][type][0].percentage || 0) + parseFloat(newState.accounting.journals.conditions[row][type][part].percentage);
				}

				newState.accounting.journals.conditions[row][type].splice(part, 1);

				// if there are no parts left, remove the row
				if (newState.accounting.journals.conditions[row][type].length === 0) {
					newState.accounting.journals.conditions.splice(row, 1);
				}
			}

			if (field) {
				newState.accounting.journals.conditions[row][type][part][field] = value;

				if (field === "when") {
					newState.accounting.journals.conditions[row][type][part].is = null;
				}
				if (field === "set") {
					newState.accounting.journals.conditions[row][type][part].to = null;
				}
				if (field === "percentage") {

					const partsWithPercentage = newState.accounting.journals.conditions[row][type].filter(part => part.percentage != null);
					const indexOfPartsWithPercentage = partsWithPercentage.map(part => newState.accounting.journals.conditions[row][type].indexOf(part));

					// if percentage is lower than 100, ensure that there are enough parts to make up 100
					const total = partsWithPercentage.reduce((acc, part) => acc + (parseFloat(part.percentage || 0)), 0);
					if (total != 100) {
						// if this is not the last item with a percentage; set the percentage of the last item to make up the difference

						if (indexOfPartsWithPercentage[indexOfPartsWithPercentage.length - 1] != part) {
							const lastPart = newState.accounting.journals.conditions[row][type][indexOfPartsWithPercentage[indexOfPartsWithPercentage.length - 1]];
							lastPart.percentage = (100 - (total - lastPart.percentage));
							console.log('lastPart.percentage',lastPart.percentage,total)
						} else if (total < 100) {
							newState.accounting.journals.conditions[row][type].push({ when: null, is: null, set: null, to: null, percentage: 100 - total });
						} else if (total > 100) {
							// if total is greater than 100, show error
							newState.accounting.journals.conditions[row][type][part].error = "Total percentage cannot be more than 100";
						}

					} else {
						// remove error from any part that has it
						newState.accounting.journals.conditions[row][type].map((part) => {
							if (part.error) {
								delete part.error;
							}
						});
					}
				}
			}

			return newState;
		}

		default:
			return state;
	}
};

export default accountingReducers;
